import andre from './images/andre.png'
import anna from './images/anna.png'
import louise from './images/louise.png'
import martin from './images/martin.png'
import philip from './images/philip.png'
import victor from './images/victor.png'

const teamMembers = [
    {
        name: "Martin Andersson",
        image: martin,
        linkedIn: "https://www.linkedin.com/in/martin-andersson-877146140/",
        mail: "martin.vg.andersson@gmail.com"
    },
    {
        name: "Victor Cousin",
        image: victor,
        linkedIn: "https://www.linkedin.com/in/victor-cousin-063a851a7/",
        mail: "victorcou123@gmail.com "
    },
    {
        name: "Philip Lindström Rabia",
        image: philip,
        linkedIn: "https://www.linkedin.com/in/philip-lindström-rabia-b30875206/",
        mail: "philip.rabia@hotmail.com"
    },
    {
        name: "Anna Rikardsson",
        image: anna,
        linkedIn: "https://www.linkedin.com/in/anna-rikardsson-a0b216169/",
        mail: "annarik@chalmers.se"
    },
    {
        name: "Louise Tranborg",
        image: louise,
        linkedIn: "https://www.linkedin.com/in/louise-tranborg-94734b1a3/",
        mail: "tranborg@chalmers.se"
    },
    {
        name: "André Wahlberg",
        image: andre,
        linkedIn: "https://www.linkedin.com/in/wahlbergandre/",
        mail: "andre.wahlberg@outlook.com"
    },
];

export default teamMembers;